import { client } from "api";
import { Company } from "models/Company";
import { CompanyComment } from "models/CompanyComment";

export type DeleteCommentRequest = { companyId: Company["id"] } & Pick<CompanyComment, "id">;

export type DeleteCommentResponse = CompanyComment[];

export const deleteComment = ({ companyId, id }: DeleteCommentRequest) =>
  client.delete<DeleteCommentResponse>(`/company/${companyId}/comments/${id}`).then((res) => res.data);
